// @ts-nocheck
import React, { useState } from "react";
import { Box, IconButton, Button, Switch } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { useNavigate } from "react-router-dom";

const RecommendedVenue = ({ type }) => {
  const navigate = useNavigate();
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const [selectedIds, setSelectedIds] = useState([]);

  let rows = [];
  let columns = [];

  const handleUpdate = () => {
    // Add your logic here (e.g., bulk update)
  };

  // Shared column structure
  const nameColumn = {
    field: "name",
    headerName: "Name",
    flex: 1,
    minWidth: 220,
    renderCell: (params) => (
      <div className="user_block click_action">
        <p>
          <b>{params.row.name}</b> <span>{params.row.email}</span>
        </p>
      </div>
    ),
  };

  const actionColumn = {
    field: "action",
    headerName: "Action",
    minWidth: 130,
    renderCell: () => (
      <div className="table_actions v2">
        <Box>
          <IconButton>
            <img src="/static/images/eye_icon.svg" alt="" />
          </IconButton>
        </Box>
        <Box>
          <IconButton onClick={() => navigate("/manage-venue-owners/edit")}>
            <img src="/static/images/edit2_icon.svg" alt="" />
          </IconButton>
        </Box>
        <Box>
          <IconButton>
            <img src="/static/images/trash2_icon.svg" alt="" />
          </IconButton>
        </Box>
      </div>
    ),
  };

  if (type === "pending") {
    rows = [
      {
        id: 1,
        name: "John Doe",
        email: "john.doe@example.com",
        venue: "Venue A",
        date: "2024-07-26",
      },
      {
        id: 2,
        name: "Jane Smith",
        email: "jane.smith@example.com",
        venue: "Venue B",
        date: "2024-07-27",
      },
    ];
    columns = [
      nameColumn,
      { field: "venue", headerName: "Venue", flex: 1, minWidth: 200 },
      {
        field: "date",
        headerName: "Date",
        flex: 1,
        minWidth: 150,
        align: "center",
        headerAlign: "center",
      },
      actionColumn,
    ];
  } else if (type === "accepted") {
    rows = [
      {
        id: 1,
        name: "Alice Johnson",
        email: "alice.j@example.com",
        venue: "Venue C",
        bookings: 15,
      },
      {
        id: 2,
        name: "Bob Williams",
        email: "bob.w@example.com",
        venue: "Venue D",
        bookings: 25,
      },
    ];
    columns = [
      nameColumn,
      { field: "venue", headerName: "Venue", flex: 1, minWidth: 200 },
      {
        field: "bookings",
        headerName: "Total Bookings",
        flex: 1,
        minWidth: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "commission",
        headerName: "Commission",
        flex: 1,
        minWidth: 150,
        align: "center",
        headerAlign: "center",
        renderCell: () => (
          <Button className="btn sm btn_primary">Manage</Button>
        ),
      },
      {
        field: "recommended",
        headerName: "Recommended",
        flex: 1,
        minWidth: 100,
        align: "center",
        headerAlign: "center",
        renderCell: () => <Switch {...label} defaultChecked />,
      },
      {
        field: "status",
        headerName: "Enable/Disable",
        flex: 1,
        minWidth: 100,
        align: "center",
        headerAlign: "center",
        renderCell: () => <Switch {...label} defaultChecked />,
      },
      actionColumn,
    ];
  } else if (type === "rejected") {
    rows = [
      {
        id: 1,
        name: "Charlie Brown",
        email: "charlie.b@example.com",
        venue: "Venue E",
        reason: "Invalid documents",
      },
      {
        id: 2,
        name: "David Miller",
        email: "david.m@example.com",
        venue: "Venue F",
        reason: "Incomplete application",
      },
    ];
    columns = [
      nameColumn,
      { field: "venue", headerName: "Venue", flex: 1, minWidth: 200 },
      {
        field: "reason",
        headerName: "Reason for Rejection",
        flex: 1,
        minWidth: 200,
        align: "center",
        headerAlign: "center",
      },
      actionColumn,
    ];
  }

  return (
    <div className="sorting_table">
      <div
        className="table_header"
        style={{ justifyContent: "flex-end", marginBottom: "12px" }}
      >
        <Button className="btn btn_primary" onClick={handleUpdate}>
          Update
        </Button>
      </div>

      <TableComponent
        columns={columns}
        rows={rows}
        checkboxSelection
        onRowSelectionModelChange={(newSelection) =>
          setSelectedIds(newSelection)
        }
        checkBox
      />
    </div>
  );
};

export default RecommendedVenue;
